import * as React from 'react';

import './HRSmallIconButton.pcss';

interface Props {
  icon:string;
  buttonText?:string;
  onClick:()=>void;
  className?:string;
}

export const HRSmallIconButton = (props: React.PropsWithChildren<Props>)=>
  <button
    className={`small-icon-button ${props.className}`}
    onClick={props.onClick}>
      <span className="material-symbols-outlined">{props.icon}</span>{props.buttonText}
  </button>
